const delay = async (ms: number = 4000) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export default delay;
